import { TElement } from "@udecode/plate-common";
import { z } from "zod";

export function isDefined<T>(value: T | null | undefined): value is NonNullable<T> {
    return value !== null && value !== undefined;
}

const zText = z.object({
    text: z.string(),
    bold: z.literal(true).optional(),
    italic: z.literal(true).optional(),
});

const zElement: z.ZodType<TElement> = z.object({
    type: z.string(),
    children: z.array(z.union([zText, z.lazy(() => zElement)])),
});

export const zRichText = z.array(zElement);

export type RichText = z.infer<typeof zRichText>;
